export default "__VITE_ASSET__BJHExmZP__"